export const HandleNumbericInput = (
  event,
  isOctalAllowed
) => {
  const inputValue = event?.target?.value
    ?.toString()
    ?.includes(',')
    ? event?.target?.value?.replace(/,/g, '')
    : event?.target?.value?.toString();
  const persianValue = inputValue?.replace(/[۰-۹]/g, (d) =>
    '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)
  );

  return isOctalAllowed
    ? persianValue
    : Number(persianValue);
};

export const HandleNumericKeyDown = (event) => {
  // Allow: backspace, delete, tab, escape, enter and .
  if (
    event.keyCode === 46 ||
    event.keyCode === 8 ||
    event.keyCode === 9 ||
    event.keyCode === 27 ||
    event.keyCode === 13 ||
    (event.keyCode === 190 && event.shiftKey === false)
  ) {
    // Do nothing.
  } else {
    // Ensure that it is a number and stop the keypress.
    if (
      (event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }
};
